import { SERVICEFLOW } from '../utils/constants.json';

const INITIAL_STATE = {
  listData: [],
  beatsArray: [],
  merchantDetailsList: [],
  selectedMerchantDetails: {},
  beatRequestType: '',
  tagsList: {},
  selectedBeatIds: [],
  fetchedMids: [],
  fseWorkingHours: {},
  facingIssueList: [],
  mapInstanceBounds: {},
  selectedZones: {},
  rescheduledBeatId: '',
  facingIssueBeatId: '',
  sendToMHDBeatId: '',
  totalServiceBeatCount: 0,
};

export default function (state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case SERVICEFLOW.LIST_VIEW_ID:
      return { ...state, ...payload };
    case SERVICEFLOW.BEATS_ARRAY:
      return { ...state, ...payload };
    case SERVICEFLOW.UPDATE:
      return { ...state, ...payload };
    case SERVICEFLOW.MERCHANT_DETAILS_LIST:
      return { ...state, ...payload };
    case SERVICEFLOW.SELECTED_MERCHANT_DETAILS:
      return { ...state, ...payload };
    case SERVICEFLOW.MERCHANT_TO_SERVICEFLOW:
      return { ...state, ...payload };
    case SERVICEFLOW.BEAT_REQUEST_TYPE:
      return { ...state, ...payload };
    case SERVICEFLOW.TAGS_SUCCESS:
      return { ...state, ...payload };
    case SERVICEFLOW.SELECTED_BEAT_IDS:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_SELECT_ALL_FLAG:
      return { ...state, ...payload };
    case SERVICEFLOW.MERCHANT_DETAILS_LIST_FETCHED_MIDS:
      return { ...state, ...payload };
    case SERVICEFLOW.FSE_WORKING_HOURS:
      return { ...state, ...payload };
    case SERVICEFLOW.IS_SERVICE_FLOW:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_MAP_DEFAULT:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_MARKER_VALUE:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_ACCORDION:
      return { ...state, ...payload };
    case SERVICEFLOW.SEARCH_MERCHANT_DETAILS:
      return { ...state, ...payload };
    case SERVICEFLOW.SELECTED_ZONE_LIST:
      return { ...state, ...payload };
    case SERVICEFLOW.RESCHEDULED_BEAT_ID:
      return { ...state, ...payload };
    case SERVICEFLOW.FACING_ISSUE_BEAT_ID:
      return { ...state, ...payload };
    case SERVICEFLOW.SEND_TO_MHD_BEAT_ID:
      return { ...state, ...payload };
    case SERVICEFLOW.SEARCH_MERCHANT:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_EMP_ID:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_PROVISONED_TL_DETAILS:
      return { ...state, ...payload };
    case SERVICEFLOW.SET_HEADER_TAB:
      return { ...state, ...payload };
    case SERVICEFLOW.TOTAL_SERVICE_BEATS_COUNT:
      return { ...state, ...payload };
    default:
      return state;
  }
}
